import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export interface DirectoryCircle {
  id: string;
  slug: string;
  name: string;
  kind: string;
  description: string | null;
  cadence: string | null;
  is_private: number;
  status: string;
  member_count: number;
  prompt_preview: string | null;
}

interface Props {
  circle: DirectoryCircle;
}

export function CircleCard({ circle }: Props) {
  return (
    <Link
      to={`/app/circles/${circle.slug}`}
      className="panel p-6 block animate-fade-up hover:border-veil/70 transition-colors group"
    >
      <div className="flex items-start justify-between gap-6">
        <div className="flex-1 min-w-0">
          <p className="label-eyebrow">
            {circle.kind}
            {circle.cadence && <span className="text-muted"> · {circle.cadence}</span>}
            {circle.is_private === 1 && (
              <span className="ml-2 inline-flex items-center gap-1 text-muted">
                <Lock className="size-3" strokeWidth={1.5} />
                private
              </span>
            )}
          </p>
          <h3 className="mt-2 font-display text-xl tracking-tight group-hover:text-gold-glow transition-colors">
            {circle.name}
          </h3>
          {circle.description && (
            <p className="mt-2 text-sm text-fog/90 leading-relaxed line-clamp-2">
              {circle.description}
            </p>
          )}
          {circle.prompt_preview && (
            <p className="mt-4 text-xs text-whisper leading-relaxed line-clamp-2">
              <span className="text-gold-glow">This week — </span>
              {circle.prompt_preview}
            </p>
          )}
        </div>
        <div className="text-right shrink-0 text-[10px] uppercase tracking-[0.18em] text-muted">
          <div className="text-whisper tabular-nums">{circle.member_count}</div>
          <div>{circle.member_count === 1 ? "member" : "members"}</div>
        </div>
      </div>
    </Link>
  );
}
